 /* eslint-disable */
import React, { Component } from "react"
import {  Row, Col,OverlayTrigger,Tooltip } from 'react-bootstrap'
import { PropTypes } from "prop-types"
import { 
	setUserRole 
} from "../../../redux/actions/action_user"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from "react-router-dom"
import ContentWrapper from '../../layout/ContentWrapper'
import { tooltips } from '../../../utils/tooltip'
import {URL} from '../../../config'
import userManager from '../../../userManager'
import { checkRole } from '../../../utils/helperfunctions'
import { getRequest } from '../../../utils/httpRequest'
import {  warning, orange } from '../../../utils/constants'

const tooltip = (message) =>  (
    <Tooltip id="tooltip">
      <strong> {message} </strong>
    </Tooltip>
  )
 class Dashboard extends Component {

		constructor(props)
		{
			super(props)
			this.state = {
				eventsLastWeek:0, 
				resultsUploaded:0,
				userRequests:0,
				exceptionsFound:0,
				upcomingEvents:0,
				lastRanking:'01/01/0001',
				isAdmin:false,
				roleChecked:false
			}
			this.getRecentActivities = this.getRecentActivities.bind(this)
			this.applyPermission = this.applyPermission.bind(this)
		}  
		componentDidMount()
		{
			const { oidc}    = this.props
		    const _this = this		
			if (oidc.user == null)
			{
				userManager.signinRedirect().then(function(user) {
					_this.applyPermission()
				})
			}
		}
		getRecentActivities(ssoEmail,isAdmin) {
			const statsendpoint = `/recentactivity/${ssoEmail}/${isAdmin}`
			const token = this.props.oidc.user.access_token
			let  eventURL =  `${URL.event}${statsendpoint}` 
			const _this = this
			getRequest(eventURL,'json',token).then(function(response){
				const { eventsLastWeek, resultsUploaded,userRequests,exceptionsFound, upcomingEvents,lastRanking } = response.data
				_this.setState({ 
					eventsLastWeek, 
					resultsUploaded,
					userRequests,
					exceptionsFound,
					upcomingEvents,
					lastRanking 
				})
			})
		}
		applyPermission()
		{
			const { dispatch, setUserRole} = this.props
			const { user } = this.props.oidc
			const {roleChecked} = this.props.user
	
			if ((user != null) && (!roleChecked))
			{
				const token = user.access_token
				const _this = this

				setUserRole(false)

				checkRole(token).then(function(response) {					
					const isAdmin = response.data
					setUserRole(isAdmin)
					const ssoEmail  = _this.props.oidc.user.profile.email		
					_this.getRecentActivities(ssoEmail,isAdmin)
					
				})
			}
		}
    render() {
        
			const { 
				eventsLastWeek, resultsUploaded,userRequests,
				exceptionsFound, upcomingEvents,lastRanking
			} = this.state

			const { isAdministrator } = this.props.user

			const lastRun = moment(lastRanking).format('L') === '01/01/0001' ? 'None' :  moment(lastRanking).format('L')
			const metricAlignment = {paddingLeft:'30px'}    
			const { oidc } = this.props
			const uservalidated = oidc.user != null

			this.applyPermission()

			return (
				uservalidated && (<ContentWrapper>
					<div className="content-heading">Dashboard</div>
						<Row>
							<Col sm={6} >
								<h5>Click on any of the metrics for more detailed information.</h5>
								<p />
							</Col>
						</Row>    
						<Row style={{ marginTop:'20px' }}>
						<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.eventstatus)}>
							<Col lgOffset={1} lg={2}  sm={ 6 }>
								<div className="panel widget bg-primary"  style={{ cursor: 'pointer', fontSize:'83%' }}>
                  <Link to="results"  style={{ color: 'white' }}>
										<Row className="row-table">
											<Col xs={ 3 } className="text-left bg-primary-dark pv-sm" style={{paddingLeft:'7px'}}>
												<em className="icon-cloud-upload fa-2x" />
											</Col>
											<Col xs={ 9 } className="pv-lg">
												<div className="h5 mt0" style={metricAlignment}>{resultsUploaded} of {eventsLastWeek}</div>
												<div>Results Uploaded</div>
											</Col>
										</Row>
									</Link>
								</div>
							</Col>
						</OverlayTrigger> 
						<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.eventsthisweek)}>      
								<Col lg={ 2 } sm={ 6 }>
									{ /* START widget */ }
									<div className="panel widget bg-purple"  style={{ cursor: 'pointer', fontSize:'83%' }}>
										<Link to="event"  style={{ color: 'white' }}>
											<Row className="row-table">
												<Col xs={ 3 }  className="text-left bg-purple-dark pv-sm" style={{paddingLeft:'9px'}}>
													<em className="fa fa-calendar fa-2x" />
												</Col>
												<Col xs={ 9 } className="pv-lg">
													<div className="h5 mt0" style={metricAlignment}>{upcomingEvents}</div>
													<div> Events this week</div>
												</Col>
											</Row>
											</Link>
									</div>
								</Col>
						</OverlayTrigger>
						{
							isAdministrator && (<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.lastrankingrun)}>         
							<Col lg={ 2 } md={ 6 } sm={ 12 }>
								{ /* START widget */ }
								<div className="panel widget bg-green"  style={{ cursor: 'pointer', fontSize:'83%' }}>
								<Link to="/lastrun"  style={{ color: 'white' }}>
									<Row className="row-table">
										<Col xs={ 3 } lg={3} className="text-left bg-green-dark pv-sm" style={{paddingLeft:'6px'}}>
											<em className="fa fa-clock-o fa-3x" />
										</Col>
										<Col xs={ 9 } lg={9} className="pv-lg">
											<div className="h5 mt0">{lastRun}</div>
											<div>Last Ranking Run</div>
										</Col>
									</Row>
									</Link>
								</div>
							</Col>
							</OverlayTrigger>)
						}  
						{
							isAdministrator && (<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.userrequests)}>        
							<Col lg={ 2 } sm={ 6 }>
							<div className="panel widget"  style={{ cursor: 'pointer', backgroundColor:'#3b5998', fontSize:'83%' }}>
								<Link to="/usermanagement"  style={{ color: 'white' }}>
								<Row className="row-table">
									<Col xs={ 3 } className="text-left pv-sm" style={{ backgroundColor:'#3b5980',paddingLeft:'8px' }}>
										<em className="fa fa-users fa-2x" />
									</Col>
									<Col xs={ 9 } className="pv-lg">
										<div className="h5 mt0" style={metricAlignment}>{userRequests}</div>
										<div>User Requests</div>
									</Col>
								</Row>
								</Link>
							</div>
							</Col>
						</OverlayTrigger>)
						}
						{
							isAdministrator && (<OverlayTrigger placement="bottom" overlay={tooltip(tooltips.exceptions)}>        
								<Col lg={ 2 } sm={ 6 }> 
									<div className="panel widget"  style={{ cursor: 'pointer', fontSize:'83%',  backgroundColor:orange }}>
										<Link to="exceptions"  style={{ color: 'white' }}>
										<Row className="row-table">
											<Col xs={ 4 } lg={3} className="text-left pv-sm" style={{ backgroundColor:warning,paddingLeft:'8px' }} >
												<em className="fa fa-warning fa-2x" />
											</Col>
											<Col xs={ 8 } lg={9} className="pv-lg">
												<div className="h5 mt0" style={metricAlignment}>{exceptionsFound}</div>
												<div>Exceptions found</div>
											</Col>
										</Row>
										</Link>
									</div>
								</Col>
						</OverlayTrigger>)
						}  
							</Row>
             </ContentWrapper>)
        )
    }
}
Dashboard.propTypes = {
	dispatch:PropTypes.func,
	checkUserRole:PropTypes.func,
	setUserRole:PropTypes.func
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setUserRole
	},dispatch)
}
const mapStateToProps = ({  oidc, user }) => {
	return {
		oidc: { ...oidc },
		user: { ...user}
	}
}
export default connect(mapStateToProps,mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/index.js